import React from 'react';
import Button from '@material-ui/core/Button';

export default function CommonButton({
    type = 'button',
    children,
    className = '',
    onClick,
    disabled,
    icon = null,
    style,
    color,
    ...props
}) {
    let Icon = icon;
    // console.log(type, props)

    return (
        <Button
            type={type}
            disabled={disabled}
            className={`commonBtn ${color ? color : 'btn-orange'}  ${disabled ? 'btn-gray not-allowed' : ''} ${className}`}
            variant="contained"
            onClick={onClick}
            style={style}
            {...props}
        >
            {Icon && (
                <Icon className='mr-2' />
            )}
            {children}
        </Button>
    );
}
